/**
 * Availability domain constants
 */

/**
 * Default availability filter
 */
export const DEFAULT_AVAILABILITY_FILTER = {
  isAvailable: undefined,
}

/**
 * Default availability stats
 */
export const DEFAULT_AVAILABILITY_STATS = {
  totalFactories: 0,
  totalVariants: 0,
  totalAvailable: 0,
  totalUnavailable: 0,
  coveragePercentage: 0,
}
